import { PropTypes } from 'prop-types';
import React from 'react';
import Calendar from 'shared-assets/components/Calendar';
import styled from 'styled-components';
import ClickOutside from 'react-click-outside';
import styles, { cardStyle } from 'shared-assets/lib/styles';

const Popover = styled.div`
  ${cardStyle};
  max-width: 19.3rem;
  position: absolute;
  left: 0;
  border: ${styles.border.default};
  padding: 0.5rem;
  z-index: 3;
`;

class DatePicker extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  close = () => {
    this.setState({
      isPickerVisible: false,
    });
  };

  open = () => {
    this.setState({
      isPickerVisible: true,
    });
  };

  handleDateSelection = date => {
    this.props.onChange(date);
    this.close();
  };

  render() {
    return (
      <ClickOutside onClickOutside={this.close}>
        <div style={{ position: 'relative' }}>
          <div
            ref={c => {
              this.childRef = c;
            }}
          >
            {this.props.children({ open: this.open, close: this.close })}
          </div>
          <If condition={this.state.isPickerVisible}>
            <Popover
              style={
                this.props.displayToTop
                  ? { top: 'auto', bottom: '100%' }
                  : {
                      top: this.childRef.getBoundingClientRect().height,
                    }
              }
            >
              <Calendar
                date={this.props.value}
                onChange={this.handleDateSelection}
                showMonthAndYearSelection={this.props.showMonthAndYearSelection}
                yearLimitEnabled={this.props.yearLimitEnabled}
                numFutureYears={this.props.numFutureYears}
                numPastYears={this.props.numPastYears}
                timeZone={this.props.timeZone}
              />
            </Popover>
          </If>
        </div>
      </ClickOutside>
    );
  }
}

DatePicker.defaultProps = {
  value: undefined,
  showMonthAndYearSelection: false,
  yearLimitEnabled: false,
  numFutureYears: 3,
  numPastYears: 3,
  timeZone: 'local',
  displayToTop: false,
};

DatePicker.propTypes = {
  children: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string, // iso8601 date
  showMonthAndYearSelection: PropTypes.bool,
  yearLimitEnabled: PropTypes.bool,
  numFutureYears: PropTypes.number,
  numPastYears: PropTypes.number,
  timeZone: PropTypes.string,
  displayToTop: PropTypes.bool,
};

export default DatePicker;
